module.exports = __webpack_public_path__ + "static/img/btn_5.780b3684.jpg";